// Runtime configuration accessor
// Config is loaded via window.APP_CONFIG from /config.js

/**
 * Gets a configuration value
 * @param {string} key - Configuration key
 * @param {*} defaultValue - Default value if key not found
 * @returns {*} Configuration value or default
 */
export const getConfig = (key, defaultValue = '') => {
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    return window.APP_CONFIG[key] !== undefined 
      ? window.APP_CONFIG[key] 
      : defaultValue;
  }
  return defaultValue;
};

export const isLenderPortfolioApiEnabled = () => {
  const value = getConfig('ENABLE_LENDER_PORTFOLIO_API', false);
  return value === true || value === 'true';
};

/**
 * Gets all configuration
 * @returns {Object} Complete configuration object
 */
export const getAllConfig = () => {
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    return window.APP_CONFIG;
  }
  return {};
};

/**
 * Checks if configuration is loaded
 * @returns {boolean} True if config is available
 */
export const isConfigLoaded = () => {
  return typeof window !== 'undefined' && 
         window.APP_CONFIG !== undefined && 
         window.APP_CONFIG !== null;
};

export default getConfig;
